import { type Template, TemplateType } from '../template/types';
import { useTemplate } from '../template';

interface UseTemplatesControlsWithoutLicenseParams {}

export const useTemplatesControlsWithoutLicense =
	({}: UseTemplatesControlsWithoutLicenseParams) => {
		const { template: activeTemplate, setActiveTemplatePreview } = useTemplate();

		const onTemplateClick = (template: Template) => {
			if (template.type === TemplateType.Link) {
				window.open(template.url, '_blank');
			} else {
				setActiveTemplatePreview(template);
			}
		};

		return {
			props: {
				activeTemplate,
				onTemplateClick,
				isDisabled: false,
			},
		};
	};
